/**
 * Selector de Zona global en la cabecera. Cambia la zona comercial activa que
 * aplican Licitaciones, Clientes 360 y Business Review (y sus exportaciones).
 */
import React, { useEffect, useState } from "react";
import axios from "axios";
import { MapPin, ChevronDown } from "lucide-react";
import { API } from "@/context/AuthContext";
import { useZona } from "@/context/ZonaContext";

export function GlobalZonaSelector() {
  const { zonaGlobal, setZonaGlobal } = useZona();
  const [zonas, setZonas] = useState([]);

  useEffect(() => {
    axios.get(`${API}/zonas`)
      .then(({ data }) => setZonas([...(data.zonas || []), data.sin_zona].filter(Boolean)))
      .catch(() => {});
  }, []);

  const active = !!zonaGlobal;
  const current = zonas.find((z) => z.codigo === zonaGlobal);

  return (
    <div className="relative hidden md:flex items-center" data-testid="global-zona-selector">
      <MapPin size={13} className={`absolute left-2.5 pointer-events-none ${active ? "text-[#007934]" : "text-gray-400"}`} />
      <select
        value={zonaGlobal}
        onChange={(e) => setZonaGlobal(e.target.value)}
        data-testid="global-zona-select"
        title="Filtro de zona global (Licitaciones, Clientes 360, Business Review)"
        className={`appearance-none text-xs rounded-lg pl-7 pr-7 py-1.5 border transition-colors cursor-pointer font-medium ${active ? "border-[#007934] bg-[#F0FDF4] text-[#007934]" : "border-gray-200 bg-gray-50 text-gray-500 hover:border-gray-300"}`}
      >
        <option value="">Todas las zonas</option>
        {zonas.map((z) => (
          <option key={z.codigo} value={z.codigo}>
            {z.nombre_visible}{z.responsable ? ` · ${z.responsable}` : ""}
          </option>
        ))}
      </select>
      <ChevronDown size={13} className="absolute right-2 pointer-events-none text-gray-400" />
      {current && current.responsable && (
        <span className="sr-only">Zona activa: {current.nombre_visible} · {current.responsable}</span>
      )}
    </div>
  );
}
